// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"916863f7","787":"ae17d97f","995":"2470173d"}[chunkId] + ".chunk.js";
};